import { ADFEncoder } from '@atlaskit/renderer/utils';
import { findFilepaths, isLinkInMatches } from '@atlaskit/editor-common/utils';

import type { ConfluenceDeepResearchPageCreateCommandProperties } from '@atlassian/rovo-content-bridge-api-commands';
import { AiMateMarkdownTransformer } from '@atlassian/conversation-assistant-content-transformer';

import { type PassThroughCommandProperties } from './types/command-handler-types';
import { StreamingCommandHandler } from './types/streaming-command-handler';

export class DeepResearchCommandHandler extends StreamingCommandHandler<ConfluenceDeepResearchPageCreateCommandProperties> {
	// Streaming Markdown -> ADF encoder for Deep Research content
	private streamingAdfEncoder: ADFEncoder<string>;
	private streamedMd = '';

	constructor(properties: PassThroughCommandProperties) {
		super(properties, 'deep-research-create');
		const pluginConfig = {
			linkify: { findFilepaths, isLinkInMatches },
			smartLinks: { regexStorage: globalThis.localStorage },
		};
		this.streamingAdfEncoder = new ADFEncoder(
			(schema) => new AiMateMarkdownTransformer(schema, pluginConfig, true),
		);
	}

	async process(params: ConfluenceDeepResearchPageCreateCommandProperties): Promise<void> {
		if (params.isStreamComplete) {
			this.streamedMd = params.data.content;
		} else {
			this.streamedMd += params.data.content;
		}

		const adfDoc = this.streamingAdfEncoder.encode(this.streamedMd);

		// Temporarily using replaceDocument since the editor streaming plugin does not support streaming MD or multiple ADF docs
		this.properties.editorAPI.core.actions.replaceDocument(adfDoc, { scrollIntoView: false });
	}

	async finish(): Promise<void> {
		this.streamedMd = '';
	}

	abort(): void {
		// No-op
	}
}
